import React, { useState, useEffect, useRef } from 'react';
import './AboutSmartlight.css'; // Standard CSS import

import adScreenshot1 from '../Images/AboutUs1.webp';
import adScreenshot2 from '../Images/AboutUs2.webp'; 
import adScreenshot3 from '../Images/AboutUs3.webp'; 

const AboutSmartlight = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  // Intersection Observer logic to trigger animations on scroll
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(entry.target);
        }
      },
      { threshold: 0.2 }
    );
    const currentRef = sectionRef.current;
    if (currentRef) {
      observer.observe(currentRef);
    }
    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, []);

  const articleImages = [adScreenshot1, adScreenshot2, adScreenshot3];

  return (
    <section 
      ref={sectionRef} 
      className={`about-section ${isVisible ? 'is-visible' : ''}`}
    >
      <div className="container">
        <div className="text-wrapper">
          <h2 className="heading">
            A Testament to Our Craft: 
            <strong> Featured by the Best</strong>
          </h2>
          <p className="description">
            Smartlight Pvt Ltd was recently honored with a feature in India's leading design publication, 
            <strong> Architectural Digest</strong>. This recognition places our Surat-based team among the nation's elite,
            celebrating our commitment to blending innovative technology with timeless design.
          </p>
          <p className="description">
            We are proud to be the official <strong>AD List Partner for 2025</strong>,
            a title that fuels our passion for illuminating the future.
          </p>
          
          {/* --- THIS IS THE NEW "READ MORE" BUTTON --- */}
          {/* It's an `<a>` tag because it links to an external site. */}
          {/* `target="_blank"` opens it in a new tab. */}
          {/* `rel="noopener noreferrer"` is a security best practice for external links. */}
          <a 
            href="https://www.architecturaldigest.in/ad-list/profile/smartlight/" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="read-more-btn"
          >
            Read Full Feature
          </a>

        </div>

        <div className="image-grid">
          {articleImages.map((imgSrc, index) => (
            <div 
              key={index} 
              className="image-wrapper"
              style={{'--delay': `${index + 1}`}}
            >
              <img src={imgSrc} alt={`Architectural Digest feature shot ${index + 1}`} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AboutSmartlight;